import commonApi from './CommonApi.js';

export default {
	searchPartyByDateRange: async (parameters) => {
		console.log(parameters);
		return await commonApi().get('/modifications/search-party-by-date-range', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
			.then((response) => {
				return response;
			})
			.catch((error) => {
				console.log(error.response);
				if (error.response.data.status === 400) {
					return error.response.data;
				}
				else {
					console.log(error.response);
				}
			});
	},
	searchEntityByAnnexAndPartyAndDateRange: async (parameters) => {
		console.log(parameters);
		return await commonApi().get('/modifications/search-entity-by-annex-and-party-and-date-range', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	searchNoteByAnnexAndPartyAndDateRange: async (parameters) => {
		console.log(parameters);
		return await commonApi().get('/modifications/search-note-by-annex-and-party-and-date-range', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	searchGoodByAnnexAndPartyAndDateRange: async (parameters) => {
		console.log(parameters);
		return await commonApi().get('/modifications/search-good-by-annex-and-party-and-date-range', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	searchServiceByAnnexAndPartyAndDateRange: async (parameters) => {
		console.log(parameters);
		return await commonApi().get('/modifications/search-service-by-annex-and-party-and-date-range', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	searchConstructionServiceByAnnexAndPartyAndDateRange: async (parameters) => {
		console.log(parameters);
		return await commonApi().get('/modifications/search-construction-service-by-annex-and-party-and-date-range', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	downloadFile: async (parameters) => {
		console.log(parameters);
		return await commonApi().get('/modifications/downloadDocument', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	searchHistoryEntities: async (parameters) => {
		return await commonApi().get('/modifications/search-history-entities', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	searchHistoryNotes: async (parameters) => {
		return await commonApi().get('/modifications/search-history-notes', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	searchHistoryNoteItems: async (parameters) => {
		return await commonApi().get('/modifications/search-history-note-items', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	searchHistoryGoods: async (parameters) => {
		return await commonApi().get('/modifications/search-history-goods', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	searchHistoryServices: async (parameters) => {
		return await commonApi().get('/modifications/search-history-services', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	searchHistoryConstructionServices: async (parameters) => {
		return await commonApi().get('/modifications/search-history-construction-services', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	}
}